/**
 * @file
 * Collapsible badge list behavior.
 *
 * Truncates long badge/keyword lists with a "+N more" toggle pill.
 * Uses Drupal behaviors with once() for proper attachment/detachment.
 */

((Drupal, once) => {
  const EXPANDED_CLASS = 'is-expanded';
  const TOGGLE_SELECTOR = '[data-badges-toggle]';
  const OVERFLOW_SELECTOR = '[data-badge-overflow]';

  Drupal.behaviors.badgesCollapse = {
    attach(context) {
      const toggleButtons = once('badges-collapse', TOGGLE_SELECTOR, context);

      for (const button of toggleButtons) {
        const collapsedLabel = button.textContent.trim();

        button.addEventListener('click', () => {
          const container = button.closest('[data-badges-collapse]');
          if (!container) {
            return;
          }

          const isExpanded = container.classList.toggle(EXPANDED_CLASS);
          button.setAttribute('aria-expanded', String(isExpanded));
          button.textContent = isExpanded
            ? Drupal.t('Show less')
            : collapsedLabel;

          // Toggle visibility of overflow items (supports inline-hidden items).
          const overflowItems = container.querySelectorAll(OVERFLOW_SELECTOR);
          for (const item of overflowItems) {
            item.style.display = isExpanded ? '' : 'none';
          }
        });
      }
    },

    detach(context, _settings, trigger) {
      if (trigger === 'unload') {
        once.remove('badges-collapse', TOGGLE_SELECTOR, context);
      }
    },
  };
})(Drupal, once);
